import React, { useEffect, useState } from "react";
import cx from "classnames";
import classes from "./TokenSelectorStyles.module.scss";
import { BiChevronDown } from "react-icons/bi";
import dropDownIcon from "img/DROP_DOWN.svg";
import "./TokenSelector.css";
import { bigNumberify, expandDecimals } from "lib/numbers";
import { getToken } from "config/tokens";
import { importImage } from "lib/legacy";
import { ModalBase } from "../Modals/ModalBase/ModalBase";

export default function TokenSelector(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const tokenInfo = getToken(props.chainId, props.tokenAddress);
  const {
    tokens,
    mintingCap,
    infoTokens,
    showMintingCap,
    disabled,
    selectedTokenLabel,
    showBalances = true,
    showTokenImgInDropdown = false,
    showSymbolImage = true,
    showNewCaret = false,
    getTokenState = () => ({ disabled: false, message: null }),
  } = props;

  const visibleTokens = tokens.filter((t) => !t.isTempHidden);

  const onSelectToken = (token) => {
    setIsModalVisible(false);
    props.onSelectToken(token);
  };

  useEffect(() => {
    if (isModalVisible) {
      setSearchKeyword("");
    }
  }, [isModalVisible]);

  if (!tokenInfo) {
    return null;
  }

  const tokenImage = showSymbolImage && importImage(`ic_${tokenInfo.symbol.toLowerCase()}_24.svg`);

  const filteredTokens = visibleTokens.filter((item) => {
    return (
      item.name.toLowerCase().indexOf(searchKeyword.toLowerCase()) > -1 ||
      item.symbol.toLowerCase().indexOf(searchKeyword.toLowerCase()) > -1
    );
  });

  return (
    <div className={cx("TokenSelector", { disabled }, props.className)}>
      {isModalVisible ? (
        <ModalBase onClose={() => setIsModalVisible(false)} title={"Select token"}>
          <div className={classes.tokenList}>
            {filteredTokens.map((token, tokenIndex) => {
              const tokenPopupImage = importImage(`ic_${token.symbol.toLowerCase()}_40.svg`);
              let info = infoTokens ? infoTokens[token.address] : {};
              const tokenState = getTokenState(info) || {};
              return (
                <div
                  key={token.address}
                  className={cx(classes.tokenWrapper, tokenState.disabled ? classes.tokenWrapperDisabled : "")}
                  onClick={() => !tokenState.disabled && onSelectToken(token)}
                >
                  <div className={classes.tokenInfo}>
                    {showTokenImgInDropdown && (
                      <img src={tokenPopupImage} alt={token.name} className={classes.tokenLogo} />
                    )}
                    <div className={classes.tokenSymbolWrapper}>
                      <div className={classes.tokenSymbol}>{token.symbol}</div>
                      <span className={classes.tokenName}>{token.name}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </ModalBase>
      ) : (
        ""
      )}
      {selectedTokenLabel ? (
        <div className={classes.tokenButtonWrapper} onClick={() => setIsModalVisible(true)}>
          {selectedTokenLabel}
        </div>
      ) : (
        <div className={classes.tokenButtonWrapper} onClick={() => setIsModalVisible(true)}>
          {showSymbolImage && (
            <img src={tokenImage} width={24} height={24} alt={tokenInfo.symbol} className={classes.tokenButtonLogo} />
          )}
          {tokenInfo.symbol}
          {!showNewCaret && <BiChevronDown className={classes.chevron} />}
        </div>
      )}
    </div>
  );
}
